import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/lib/currency";

const typeColor = {
  coin_purchase: "text-red-600",
  rent_payment: "text-red-600",
  wallet_deposit: "text-[#002FA7]",
  distribution: "text-green-600",
  rent_received: "text-green-600",
  advance_payout: "text-green-600",
  amc_setup_fee: "text-green-600",
  amc_monthly_fee: "text-green-600",
  maintenance_reserve: "text-green-600",
};

export default function Activity() {
  const { t } = useTranslation();
  const { fmt } = useCurrency();
  const [txs, setTxs] = useState([]);
  useEffect(() => { api.get("/transactions/mine").then(({ data }) => setTxs(data)).catch(()=>{}); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12">
      <div className="font-mono-label text-[11px] text-[#002FA7]">⎯⎯ {t("act_tag")}</div>
      <h1 className="font-display text-5xl font-black mt-2">{t("act_title")}</h1>

      {txs.length === 0 ? (
        <div className="border border-black/10 p-12 text-center text-zinc-500 font-mono-label text-xs mt-10">
          {t("act_empty")}
        </div>
      ) : (
        <div className="border border-black/10 mt-10 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 border-b border-black/10">
              <tr className="font-mono-label text-[10px] text-start">
                <th className="p-3 text-start">{t("act_when")}</th>
                <th className="p-3 text-start">{t("act_type")}</th>
                <th className="p-3 text-start">{t("act_desc")}</th>
                <th className="p-3 text-end">{t("act_amount")}</th>
              </tr>
            </thead>
            <tbody>
              {txs.map((tx) => (
                <tr key={tx.id} className="border-b border-black/5 hover:bg-zinc-50">
                  <td className="p-3 text-xs text-zinc-500 whitespace-nowrap">{new Date(tx.created_at).toLocaleString()}</td>
                  <td className="p-3 font-mono-label text-[10px] whitespace-nowrap">{tx.type.replace(/_/g, " ")}</td>
                  <td className="p-3 min-w-0">{tx.description}</td>
                  <td className={`p-3 text-end font-bold tabular-nums whitespace-nowrap ${typeColor[tx.type] || ""}`}>
                    {tx.amount > 0 ? "+" : ""}{fmt(tx.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
